import ToggleButton from "@/components/shared/ToggleButton";
import AmountInput from "@/components/shared/AmountInput";

const IncomeRow = ({ icon: Icon, label, income, onUpdate, index }) => {
  const handleToggle = (isMonthly) => {
    onUpdate(index, { ...income, is_monthly: isMonthly });
  };

  const handleAmountChange = (value) => {
    if (income.is_monthly) {
      onUpdate(index, { ...income, monthly_amount: value, yearly_amount: value * 12 });
    } else {
      onUpdate(index, { ...income, yearly_amount: value, monthly_amount: value / 12 });
    }
  };

  return (
    <div className="flex items-center justify-between py-4 row-divider income-row-mobile" data-testid={`income-row-${index}`}>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        <div className="category-icon"><Icon size={18} /></div>
        <span className="font-medium text-gray-700 text-sm sm:text-base">{label}</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-4 row-controls">
        <ToggleButton isMonthly={income.is_monthly} onToggle={handleToggle} dataTestId={`income-toggle-${index}`} />
        <AmountInput
          value={income.is_monthly ? income.monthly_amount : income.yearly_amount}
          onChange={handleAmountChange}
          dataTestId={`income-amount-${index}`}
        />
      </div>
    </div>
  );
};

export default IncomeRow;
